import React from 'react'
import { Layout, Menu, Icon } from 'antd'
import { Link, withRouter } from 'react-router-dom'
import {
  SettingOutlined,
  SelectOutlined,
  UserOutlined,
  TrademarkOutlined,
  InfoOutlined,
  MailOutlined,
  SendOutlined,
  ExportOutlined,
  FileTextOutlined,
  FormOutlined,
  TeamOutlined,
  UserSwitchOutlined,
  UploadOutlined,
  ControlOutlined,
  CodepenOutlined,
  IssuesCloseOutlined,
  SolutionOutlined,
  IdcardOutlined,
  CommentOutlined,
  RollbackOutlined,
  FileAddOutlined,
  ContainerOutlined,
} from '@ant-design/icons'
import HeaderDiv from '../Header/HeaderDiv'
import Home from '../pages/Home'
import hasPermissions from '../hooks/Permissions'
const { SubMenu } = Menu
const { Header, Sider, Content } = Layout
const data = JSON.parse(localStorage.getItem('user'))
class HomeLayout extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      collapsed: localStorage.getItem('collapsed') === 'true' || false,
      isSuperAdmin: data?.role === '301',
      isCustomer: data?.role === '309' || data?.role === '311',
      isBroker: data?.role === '305',
      isFinUser: data?.role === '319',
      isUnderwriter: data?.role === '303',
      rolePermissions: {},
      insurerPermission: {},
      authPermission: {},
      emailPermission: {},
      adminSettingPermission: {},
      insurerSettingPermission: {},
      userPermission: {},

      quotationPermissions: {},
      policyPermissions: {},
      customerPermissions: {},
      isInsurer: data?.RoleName === 'InsurerAdmin',
      LoginUserRole: JSON.parse(localStorage.getItem('roles')).toLowerCase(),
      openKeys: [],
      selectedKeys: [this.getSelectedKey(props.location.pathname)],
    }
  }
  getSelectedKey = pathname => {
    const pathToKeyMap = {
      '/dashboard': '1',
      '/customers': '2',
      '/quotations': '4',
      '/policies': '5',
      '/reports': '6',
      '/reinsurance-report': '13',
      '/generate-quote': '12',
      '/communication': '7',
      '/debit-note': '8',
      '/customer-statement': '9',
      '/payment-history': '71',
      '/subsciption-settings': '72',
      '/insurer-products': '52',
      '/insurer-risk-cover': '53',
      '/insurer-risk-cover-item': '54',
      '/home': '18',
    }

    // Find the matching path
    for (const [path, key] of Object.entries(pathToKeyMap)) {
      if (pathname.startsWith(path)) {
        return key
      }
    }

    return '1' // default to dashboard
  }

  renderSidebar = () => {
    const { location, children } = this.props
    const { collapsed, isSuperAdmin } = this.state
    const isHomeRoute = location.pathname.startsWith('/home')
    if (this.state.isCustomer) {
      return (
        <Sider
          trigger={null}
          collapsible
          collapsed={this.state.collapsed}
          style={{
            background: '#001529',
            minWidth: '250px',
            width: '250px',
            maxWidth: '250px',
          }}
          className="sidebar-left"
          onCollapse={this.onCollapse}>
          <div className="logo" />
          <Menu
            theme="light"
            mode="inline"
            selectedKeys={this.state.selectedKeys}
            openKeys={this.state.openKeys}
            onOpenChange={this.onOpenChange}>
            {/* <Menu.Item key="18">
              <Link to="/home">
                <div>
                  <span><RollbackOutlined /> Go Back</span>
                </div>
              </Link>
            </Menu.Item> */}

            <Menu.Item key="2">
              <Link to="/customers">
                <div>
                  <TeamOutlined />
                  <span>Customers </span>
                </div>
              </Link>
            </Menu.Item>


            <SubMenu
              key="sub3"
              title={
                <span>
                  <ContainerOutlined />
                  <span>Reports</span>
                </span>
              }
            >
              <Menu.Item key="201">
                <Link to="/reports">Policy Report</Link>
              </Menu.Item>

              <Menu.Item key="202">
                <Link to="/reinsurance-report">Reinsurance Report</Link>
              </Menu.Item>

              <Menu.Item key="203">
                <Link to="/ReinsurerAmountDueReport">Reinsurance Due Report</Link>
              </Menu.Item>

              <Menu.Item key="204">
                <Link to="/BrokerPoliciesReport">Broker Policies Report</Link>
              </Menu.Item>

              <Menu.Item key="205">
                <Link to="/ClaimPendingReport">Claim Pending Report</Link>
              </Menu.Item>

              <Menu.Item key="206">
                <Link to="/ClaimSettledReport">Claim Settled Report</Link>
              </Menu.Item>

              <Menu.Item key="207">
                <Link to="/ClaimRejectedReport">Claim Rejected Report</Link>
              </Menu.Item>

              <Menu.Item key="208">
                <Link to="/ClaimFormReport">Claim Form Report</Link>
              </Menu.Item>

            </SubMenu>


            <Menu.Item key="7">
              <Link to="/communication">
                <div>
                  <CommentOutlined />
                  <span>Communication</span>
                </div>
              </Link>
            </Menu.Item>

            <Menu.Item key="8">
              <Link to="/debit-note">
                <div>
                  <CommentOutlined />
                  <span>Debit Note</span>
                </div>
              </Link>
            </Menu.Item>

            <Menu.Item key="9">
              <Link to="/customer-statement">
                <div>
                  <SolutionOutlined />
                  <span>Statement</span>
                </div>
              </Link>
            </Menu.Item>

            <Menu.Item key="10">
              <Link to="/home/endorsement">
                <div>
                  <SolutionOutlined />
                  <span>Endorsement Request</span>
                </div>
              </Link>
            </Menu.Item>

            <SubMenu
              key="sub2"
              title={
                <span>
                  <SettingOutlined />
                  <span>Subscription</span>
                </span>
              }>
              <Menu.Item key="71">
                <Link to="/payment-history">Payment history</Link>
              </Menu.Item>
              <Menu.Item key="72">
                <Link to="/subsciption-settings">Settings</Link>
              </Menu.Item>
            </SubMenu>
          </Menu>
        </Sider>
      )
    } else {
      // render default sidebar
      return (
        <Sider
          trigger={null}
          collapsible
          collapsed={this.state.collapsed}
          style={{
            background: '#001529',
            minWidth: '250px',
            width: '250px',
            maxWidth: '250px',
          }}
          // className="sidebar-left"
          className={`sidebar-left ${this.state.collapsed ? 'collapsed' : ''}`}
          onCollapse={this.onCollapse}>
          <div className="logo" />
          <Menu theme="light" mode="inline">
            {!this.state.isFinUser && (
              <Menu.Item key="6">
                <Link to="/home">
                  {' '}
                  <div>
                    <SelectOutlined />
                    <span>Select Product </span>
                  </div>
                </Link>
              </Menu.Item>
            )}
            {isSuperAdmin ? (
              <Menu.Item key="7">
                <Link to="/home/role-permissions">
                  <div>
                    <TrademarkOutlined />
                    <span>Roles</span>
                  </div>
                </Link>
              </Menu.Item>
            ) : null}
            <Menu.Item key="8">
              <Link to="/home/user-detail">
                {' '}
                <div>
                  <InfoOutlined />
                  <span>User Detail</span>
                </div>
              </Link>
            </Menu.Item>
            {!this.state.isBroker && Object.keys(this.state.emailPermission).length > 0 ? (
              <Menu.Item key="9">
                <Link to="/home/email-template">
                  {' '}
                  <div>
                    <MailOutlined />
                    <span>Email Template</span>
                  </div>
                </Link>
              </Menu.Item>
            ) : null}
            {!this.state.isBroker && Object.keys(this.state.emailPermission).length > 0 ? (
              <Menu.Item key="10">
                <Link to="/home/assigne-templates">
                  {' '}
                  <div>
                    <ExportOutlined />
                    <span>Assigne Template</span>
                  </div>
                </Link>
              </Menu.Item>
            ) : null}
            {!this.state.isBroker && (
              this.state.insurerPermission.hasOwnProperty('11') ||
              this.state.insurerPermission.hasOwnProperty('12')
            ) ? (
              <Menu.Item key="11">
                <Link to="/home/insurerList">
                  <div>
                    <FileTextOutlined />
                    <span>Manage Insurer Products</span>
                  </div>
                </Link>
              </Menu.Item>
            ) : null}

            {this.state.authPermission.hasOwnProperty('23') > 0 ? (
              <Menu.Item key="13">
                <Link to="/home/assigne-users">
                  {' '}
                  <div>
                    <TeamOutlined />
                    <span>Assign Users</span>
                  </div>
                </Link>
              </Menu.Item>
            ) : null}
            {this.state.authPermission.hasOwnProperty('11') &&
              !this.state.isBroker ? (
              <Menu.Item key="12">
                <Link to="/home/register">
                  {' '}
                  <div>
                    <UserOutlined />
                    <span>Register</span>
                  </div>
                </Link>
              </Menu.Item>
            ) : null}

            {this.state.isSuperAdmin && (
              <Menu.Item key="32">
                <Link to="/home/users">
                  {' '}
                  <div>
                    <UserSwitchOutlined />
                    <span>Users</span>
                  </div>
                </Link>
              </Menu.Item>
            )}

            {!this.state.isBroker && (this.state.insurerSettingPermission.hasOwnProperty('27') ||
              this.state.isSuperAdmin) && (
                <Menu.Item key="25">
                  <Link to="/home/assign-underwriter">
                    {' '}
                    <div>
                      <UserSwitchOutlined />
                      <span>Assign UnderWriter</span>
                    </div>
                  </Link>
                </Menu.Item>
              )}
            {!this.state.isBroker && (this.state.insurerSettingPermission.hasOwnProperty('27') ||
              this.state.isSuperAdmin) && (
                <Menu.Item key="21">
                  <Link to="/home/assign-masterbroker">
                    {' '}
                    <div>
                      <UserSwitchOutlined />
                      <span>Assign Master Broker</span>
                    </div>
                  </Link>
                </Menu.Item>
              )}

            {!this.state.isBroker && (this.state.insurerSettingPermission.hasOwnProperty('27') ||
              this.state.isSuperAdmin) && (
                <Menu.Item key="22">
                  <Link to="/home/assign-broker">
                    {' '}
                    <div>
                      <UserSwitchOutlined />
                      <span>Assign Broker</span>
                    </div>
                  </Link>
                </Menu.Item>
              )}
            {!this.state.isBroker && !this.state.isSuperAdmin && (this.state.insurerSettingPermission.hasOwnProperty('27')) && (
              <Menu.Item key="30">
                <Link to="/home/claim/forms">
                  {' '}
                  <div>
                    <FormOutlined />
                    <span>Manage Forms</span>
                  </div>
                </Link>
              </Menu.Item>
            )}
            {!this.state.isBroker && !this.state.isSuperAdmin && (this.state.insurerSettingPermission.hasOwnProperty('27') ||
              this.state.isSuperAdmin) && (
                <Menu.Item key="31">
                  <Link to="/home/claim/manage-fields">
                    {' '}
                    <div>
                      <FileTextOutlined />
                      <span>Manage Field Types</span>
                    </div>
                  </Link>
                </Menu.Item>
              )}

            {!this.state.isBroker && this.state.insurerSettingPermission.hasOwnProperty('27') &&
              !this.state.isSuperAdmin && (
                <Menu.Item key="17">
                  <Link to="/home/claim-thresholds">
                    {' '}
                    <div>
                      <UserSwitchOutlined />
                      <span>Claim Thresholds</span>
                    </div>
                  </Link>
                </Menu.Item>
              )}
            {!this.state.isBroker && !this.state.isSuperAdmin && this.state.insurerSettingPermission.hasOwnProperty('22') && (
              <Menu.Item key="15">
                <Link to="/home/document-upload">
                  {' '}
                  <div>
                    <UserSwitchOutlined />
                    <span>Upload Documents</span>
                  </div>
                </Link>
              </Menu.Item>
            )}
            {!this.state.isBroker && !this.state.isSuperAdmin && this.state.insurerSettingPermission.hasOwnProperty('23') && (
              <Menu.Item key="16">
                <Link to="/home/assigne-document">
                  {' '}
                  <div>
                    <UserSwitchOutlined />
                    <span>Assign Documents</span>
                  </div>
                </Link>
              </Menu.Item>
            )}

            {!this.state.isBroker && (this.state.isInsurer || this.state.isCustomer || this.state.isUnderwriter || this.state.isBroker) && (
              <Menu.Item key="99">
                <Link to="/home/endorsement">
                  <div>
                    <SolutionOutlined />
                    <span>Endorsement Request</span>
                  </div>
                </Link>
              </Menu.Item>
            )}

            {this.state.userPermission.hasOwnProperty('28') && (
              <Menu.Item key="18">
                <Link to="/home/additional-info">
                  {' '}
                  <div>
                    <UserSwitchOutlined />
                    <span>Additional Info</span>
                  </div>
                </Link>
              </Menu.Item>
            )}
            {this.state.isSuperAdmin && !this.state.isSuperAdmin && (
              <Menu.Item key="19">
                <Link to="/home/bulk-upload-data">
                  {' '}
                  <div>
                    <UploadOutlined />
                    <span>Fleet Upload</span>
                  </div>
                </Link>
              </Menu.Item>
            )}
            {!this.state.isSuperAdmin && !this.state.isFinUser && (
              <Menu.Item key="20">
                <Link to="/home/premium-summery">
                  {' '}
                  <div>
                    <ControlOutlined />
                    <span>Credit Control</span>
                  </div>
                </Link>
              </Menu.Item>
            )}
            {this.state.isFinUser && (
              <Menu.Item key="71">
                <Link to="/home/policy">
                  {' '}
                  <div>
                    <ControlOutlined />
                    <span>Policy Details</span>
                  </div>
                </Link>
              </Menu.Item>
            )}
            {this.state.isBroker && (
              <Menu.Item key="23">
                <Link to="/home/diary-system">
                  {' '}
                  <div>
                    <CodepenOutlined />
                    <span>Diary System</span>
                  </div>
                </Link>
              </Menu.Item>
            )}
            {this.state.isBroker && (
              <Menu.Item key="24">
                <Link to="/home/escalate-issues">
                  {' '}
                  <div>
                    <IssuesCloseOutlined />
                    <span>Escalate Issues</span>
                  </div>
                </Link>
              </Menu.Item>
            )}
            {this.state.isInsurer && (
              <Menu.Item key="25">
                <Link to="/home/email-events">
                  {' '}
                  <div>
                    <IssuesCloseOutlined />
                    <span>Manage Email Events</span>
                  </div>
                </Link>
              </Menu.Item>
            )}

            {this.state.isInsurer && (
              <Menu.Item key="26">
                <Link to="/home/ManageDocuments">
                  {' '}
                  <div>
                    <IssuesCloseOutlined />
                    <span>Manage Documents</span>
                  </div>
                </Link>
              </Menu.Item>
            )}

            {this.state.isInsurer && (
              <Menu.Item key="29">
                <Link to="/home/ManageDocumentMapping">
                  {' '}
                  <div>
                    <IssuesCloseOutlined />
                    <span>Manage Document Mapping</span>
                  </div>
                </Link>
              </Menu.Item>
            )}


            {/* <Menu.Item key="5">
              <Link to="/home/email-events">Manage Email Events</Link>
            </Menu.Item> */}
            {Object.keys(this.state.adminSettingPermission).length > 0 && (
              <SubMenu
                key="sub1"
                title={
                  <span>
                    <SettingOutlined />
                    <span>Master Settings</span>
                  </span>
                }>
                <Menu.Item key="2">
                  <Link to="/home/manageProducts">Manage Products</Link>
                </Menu.Item>
                <Menu.Item key="3">
                  <Link to="/home/riskCover">Manage Risk Covers</Link>
                </Menu.Item>
                <Menu.Item key="4">
                  <Link to="/home/riskItem">Manage Risk Items</Link>
                </Menu.Item>

                <Menu.Item key="6">
                  <Link to="/home/generalSettings">General Settings</Link>
                </Menu.Item>
              </SubMenu>
            )}
          </Menu>
        </Sider>
      )
    }
  }

  componentDidMount() {
    const permissions = hasPermissions('Roleclaims')
    const insurer_permission = hasPermissions('Insurer')
    const register_permission = hasPermissions('Auth')
    const email_permission = hasPermissions('Email Template')
    const admin_setting_permission = hasPermissions('Admin Setting')
    const insurer_setting_permission = hasPermissions('Insurer Setting')
    const user_permission = hasPermissions('User')

    this.setState({
      rolePermissions: permissions,
      insurerPermission: insurer_permission,
      authPermission: register_permission,
      emailPermission: email_permission,
      adminSettingPermission: admin_setting_permission,
      insurerSettingPermission: insurer_setting_permission,
      userPermission: user_permission,
    })
  }

  toggleSidebar = () => {
    this.setState({ collapsed: !this.state.collapsed })
    localStorage.setItem('collapsed', !this.state.collapsed)
  }

  render() {
    const { location, children } = this.props
    const { collapsed, isSuperAdmin } = this.state

    return (
      <Layout className={`${this.props.classname}`}>
        {this.renderSidebar()}
        <Layout>
          <Header className="headerTop">
            <HeaderDiv toggleSidebar={this.toggleSidebar} />
          </Header>
          <Content
            // style={{padding: '20px', minHeight: '100vh'}}
            className={
              this.state.collapsed ? 'collapsed mainContnet ' : 'mainContnet'
            }>
            {location.pathname === '/home' ? <Home /> : children}
          </Content>
        </Layout>
      </Layout>
    )
  }
}

export default withRouter(HomeLayout)
